'use strict';
var monitoringAlarmTpl = require('../pages/alarm/alarm.html');

module.exports = /*@ngInject*/ function alarmDetails() {
    return {
        restrict: 'E',
        template: monitoringAlarmTpl,
        controller: 'AlarmMonitoringPageController',
        controllerAs: 'vm',
        scope: {
            currentTrain: '@'
        },
        bindToController: true, // because the scope is isolated,
        link: function(scope, element, attrs) {
            attrs.$observe('currentTrain', function(value){
                scope.currentTrain = value;
            });
         }
    };

};